import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import Icon from '../Icon/Icon'

const StyledIconButtonComponent = css`
  align-items: center;
  display: flex;
  border: none;
  radius: '50%';
  padding: 0;
  background-color: inherit;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
`

export const StyledIconButton = styled.button`
  ${StyledIconButtonComponent};
`

const StyledInternalIconLink = styled(Link)`
  ${StyledIconButtonComponent};
  max-width: max-content;
`

const StyledExternalIconLink = styled.a`
  ${StyledIconButtonComponent};
  max-width: max-content;
`

const IconButton = (props) => {
  const {
    absolutePath,
    ariaLabel,
    alt,
    children,
    className,
    color,
    disabled = false,
    height,
    href,
    onClick = () => {},
    size,
    svg,
    to,
    type,
    width,
    target,
  } = props

  const Element = to
    ? StyledInternalIconLink
    : href
    ? StyledExternalIconLink
    : StyledIconButton

  return (
    <Element
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
      href={href}
      onClick={onClick}
      to={to}
      target={target}
    >
      <Icon
        absolutePath={absolutePath}
        alt={alt}
        color={color}
        height={height}
        disabled={disabled}
        svg={svg}
        size={size}
        type={type}
        width={width}
      >
        {children}
      </Icon>
    </Element>
  )
}

IconButton.propTypes = {
  absolutePath: PropTypes.string,
  ariaLabel: PropTypes.string,
  alt: PropTypes.string,
  children: PropTypes.any,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  height: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string,
  svg: PropTypes.any,
  to: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
  target: PropTypes.string,
}

export default IconButton
